//document ready
$(function() {

  //redirection form old recharge urls to new portal
  var url = window.location.href;
  if (url.indexOf('customer_portal') > 0){
    $('.container.main.content').html('We’re loading your subscription. This can take up to 10 seconds—thanks for your patience!');
    var urlArray = url.split('/');
    var customerHash = urlArray[urlArray.indexOf('customer_portal')+1];
    window.location.href = 'https://uqora.com/tools/recurring/portal/'+customerHash+'/subscriptions';
  }

  new WOW().init();
    
  $(document).on('click', '.subscribe-popup-link a', function(e){
    e.preventDefault();

    $.fancybox.open({
      src:'#subscribe-modal',
      type: 'inline',
      touch:false,
      autoFocus: false,
      toolbar  : false,
      baseClass: 'subscribeModal'
    });
  });
  
/* Menu outside click close */ 
  $(document).on('click touchend touch', '.mobilemanulayer', function(e){
    if( $('.dropdown_container.show-dropdown').length > 0 ){ 
      e.preventDefault();
      
      $('.mobile_nav.dropdown_link > div').removeClass('open');
      $('.dropdown_container.show-dropdown').removeClass('show-dropdown');
      $('body').removeClass('is-active');
    } 
  });

/* Recommedation block */ 
  
$("body").on("click", '.rounded-checkbox span.label', function() {
    var isChecked = $(this).parent('.rounded-checkbox').find('input[type="checkbox"]').prop('checked');
    var checkedText = ( !isChecked ? " checked": " unchecked");
    $(this).parent('.rounded-checkbox').find('input[type="checkbox"]').prop('checked', !isChecked).trigger('change');
    var onpage = ( $('body').attr("class") == 'index' ? "home":"collection");
    //console.log($(this).text() + " Option Clicked on "+ onpage +" page, and checkbox is " +checkedText);
    ga('send', 'event', {
      eventCategory: 'Quiz engagement',
      eventAction: 'click',
      eventLabel: "Option: " + $(this).text() + "  Clicked on "+ onpage + " page, and checkbox is " + checkedText,
      transport: 'beacon'
    });
});
  
$("body").on("click", '.rounded-checkbox label', function() {
    var isChecked = $(this).parent('.rounded-checkbox').find('input[type="checkbox"]').prop('checked');
    var checkedText = ( !isChecked ? " checked": " unchecked");
    var onpage = ( $('body').attr("class") == 'index' ? "home":"collection");
    //console.log($(this).next().text() + " Option Clicked on "+ onpage +" page, and checkbox is " +checkedText);
    ga('send', 'event', {
      eventCategory: 'Quiz engagement',
      eventAction: 'click',
      eventLabel: "Option: " + $(this).next().text() + "  Clicked on "+ onpage + " page, and checkbox is " + checkedText,
      transport: 'beacon'
    });
});
  
$("body").on("click", '.learn-more-btn a', function() {
    var productName = $(this).parents('.result-block').attr('class').split(' ')[1];
    productName = productName.replace('product-', '');
    console.log(productName);
    //ga('send', 'event', 'button', 'click', productName,  'beacon');
     ga('send', 'event', {
      eventCategory: 'Learn More Link',
      eventAction: 'click',
      eventLabel: 'Learn More Link Clicked: ' + productName,
      transport: 'beacon'
    });
});  
  
$("body").on("change", '.questions-block input[type="checkbox"]', function() {
  var q1 = $('input[name="question1-check"]').prop('checked');
  var q2 = $('input[name="question2-check"]').prop('checked');
  var q3 = $('input[name="question3-check"]').prop('checked');
  
  // no selection
  if (!q1 && !q2 && !q3 ) {
    $('.result-wrap').hide();
  }
  
  // target
  if (q1 && !q2 && !q3 ) {
    $('.result-block.product-target').show();
    $('.result-block.product-control').hide();
    $('.result-block.product-promote').hide();
    $('.result-block.product-target-and-control').hide();
    $('.result-block.product-target-and-promote').hide();
    $('.result-block.product-control-and-promote').hide();
    $('.result-block.product-preventon-system').hide();
    $('.result-wrap').show();
  }
  // control
  if (!q1 && q2 && !q3 ) {
    $('.result-block.product-target').hide();
    $('.result-block.product-control').show();
    $('.result-block.product-promote').hide();
    $('.result-block.product-target-and-control').hide();
    $('.result-block.product-target-and-promote').hide();
    $('.result-block.product-control-and-promote').hide();
    $('.result-block.product-preventon-system').hide();
    $('.result-wrap').show();
  }
  // promote
  if (!q1 && !q2 && q3 ) {
    $('.result-block.product-target').hide();
    $('.result-block.product-control').hide();
    $('.result-block.product-promote').show();
    $('.result-block.product-target-and-control').hide();
    $('.result-block.product-target-and-promote').hide();
    $('.result-block.product-control-and-promote').hide();
    $('.result-block.product-preventon-system').hide();
    $('.result-wrap').show();
  }
  // control and target
  if (q1 && q2 && !q3 ) {
    $('.result-block.product-target').hide();
    $('.result-block.product-control').hide();
    $('.result-block.product-promote').hide();
    $('.result-block.product-target-and-control').show();
    $('.result-block.product-target-and-promote').hide();
    $('.result-block.product-control-and-promote').hide();
    $('.result-block.product-preventon-system').hide();
    $('.result-wrap').show();
  }
  // control-and-promote
  if (!q1 && q2 && q3 ) {
    $('.result-block.product-target').hide();
    $('.result-block.product-control').hide();
    $('.result-block.product-promote').hide();
    $('.result-block.product-target-and-control').hide();
    $('.result-block.product-target-and-promote').hide();
    $('.result-block.product-control-and-promote').show();
    $('.result-block.product-preventon-system').hide();
    $('.result-wrap').show();
  }
  // promote and target
  if (q1 && !q2 && q3) {
    $('.result-block.product-target').hide();
    $('.result-block.product-control').hide();
    $('.result-block.product-promote').hide();
    $('.result-block.product-target-and-control').hide();
    $('.result-block.product-target-and-promote').show();
    $('.result-block.product-control-and-promote').hide();
    $('.result-block.product-preventon-system').hide();
    $('.result-wrap').show();
  }

  // control, promote and target
  if (q1 && q2 && q3) {
    $('.result-block.product-target').hide();
    $('.result-block.product-control').hide();
    $('.result-block.product-promote').hide();
    $('.result-block.product-target-and-control').hide();
    $('.result-block.product-target-and-promote').hide();
    $('.result-block.product-control-and-promote').hide();
    $('.result-block.product-preventon-system').show();
    $('.result-wrap').show();
  }
  

});
/* End Recommedation block */ 
  
  
/* Remove spin weel hidden block */
  
  if ($(window).width() <= 798) { 
    $('#scm-iframe').remove();
  }
  
/* Product subscription prices update */


$("body").on("change", '.single-option-selector', function() {
  var type = $('#rc_container .rc_block__type--active input').val();
    if(type === 'autodeliver') {
      if( ($('.product-name--uqora-control').length > 0) || ($('.product-name--uqora-promote').length > 0)) {
           $(".single-option-selector option[value='2 bottles']").remove();
          $(".single-option-selector option[value='3 bottles']").remove();
      }
    } else {
      if($('.single-option-selector option').length == 1) {
          $('.single-option-selector').append('<option value="2 bottles">2 bottles</option>');
          $('.single-option-selector').append('<option value="3 bottles">3 bottles</option>');
      }
    }
  
  $('select.product_qty_select option').each(function(i){

     if($(this).text() == $('.single-option-selector').val()){
       var variant_id= $(this).data('vid');
       var subvarid = parseInt(variant_to_duplicate[variant_id], 10);
       var oldprice = variant_to_price[variant_id];
     var newprice = duplicate_to_price[subvarid];
       var discount_per = (parseInt(oldprice)-parseInt(newprice))*100/parseInt(oldprice);
       
       var discount_string = discount_per.toFixed(2) + '%';
       discount_string = discount_string.replace('.00', '');
       //console.log(variant_to_duplicate);console.log(subvarid);console.log(duplicate_to_price[subvarid]);console.log( parseInt(oldprice)-parseInt(newprice)  );
       var labelrc = 'Subscribe <span id="rc_price_autodeliver" class="rc_price rc_price__autodeliver">$46.75</span>'+
          '<span class="rc_label__discount">Saves<span class="rc_label__amount_discount">15%</span></label>';
       
       $('.rc_price_onetime').text(Shopify.formatMoney(oldprice, $('body').data('money-format')));
       if($('.single-option-selector').val() == "2 bottles" || $('.single-option-selector').val() == "3 bottles"){
         $('.rc_label__autodeliver').html('Unavailable on subscription');
       } 
       if($('.single-option-selector').val() == "1 bottle"){

         $('.rc_label__autodeliver').html(labelrc);
         $('#rc_price_autodeliver').text(Shopify.formatMoney(newprice, $('body').data('money-format')));
       }
       $('.rc_label__amount_discount').text(discount_string).show();
       
    //var type = $('#rc_container .rc_block__type--active input').val();
    /*if(type === 'autodeliver') {
      var current_text = $('.add_to_cart .text').text();
    $('.add_to_cart .text').text(current_text + " + " +Shopify.formatMoney(newprice, $('body').data('money-format'))).show();
      $('.second_add_to_cart .text').text(current_text + " + " +Shopify.formatMoney(newprice, $('body').data('money-format'))).show();
    } else {
      var current_text = $('.add_to_cart .text').text();
    $('.add_to_cart .text').text(current_text + " + " +Shopify.formatMoney(oldprice, $('body').data('money-format'))).show();
      $('.second_add_to_cart .text').text(current_text + " + " +Shopify.formatMoney(oldprice, $('body').data('money-format'))).show();
    }*/
       
  }
  });

});
  
  $("body").on("change", '.single-option-selector', function() {
    var type = $('#rc_container .rc_block__type--active input').val();
    if(type === 'autodeliver') {
      if( ($('.product-name--uqora-control-promote').length > 0)) {
           $(".single-option-selector option[value='2 bottles of each']").remove();
          $(".single-option-selector option[value='3 bottles of each']").remove();
      }
    } else {
      if($('.single-option-selector option').length == 1) {
          $('.single-option-selector').append('<option value="2 bottles of each">2 bottles of each</option>');
          $('.single-option-selector').append('<option value="3 bottles of each">3 bottles of each</option>');
      }
    }
  
  });

$("body").on("click", '#rc_container .rc_block__type--active input', function() {
    var type = $(this).val();
    var current_text = "ADD TO CART";
    var optionprice = '';
    if(type === 'autodeliver') {
        optionprice = $('#rc_price_autodeliver').text();
        if( ($('.product-name--uqora-control').length > 0) || ($('.product-name--uqora-promote').length > 0)) {
           $(".single-option-selector option[value='2 bottles']").remove();
          $(".single-option-selector option[value='3 bottles']").remove();
            $('.single-option-selector').val('1 bottle').change();
        }
        if( ($('.product-name--uqora-control-promote').length > 0)) {
           $(".single-option-selector option[value='2 bottles of each']").remove();
          $(".single-option-selector option[value='3 bottles of each']").remove();
            $('.single-option-selector').val('1 bottle of each').change();
        }
    } else {
      optionprice = $('#rc_price_onetime').text();
      if($('.single-option-selector option').length == 1) {
        if( ($('.product-name--uqora-control').length > 0) || ($('.product-name--uqora-promote').length > 0)) {
          $('.single-option-selector').append('<option value="2 bottles">2 bottles</option>');
          $('.single-option-selector').append('<option value="3 bottles">3 bottles</option>');
        }
        if( ($('.product-name--uqora-control-promote').length > 0)) {
          $('.single-option-selector').append('<option value="2 bottles of each">2 bottles of each</option>');
          $('.single-option-selector').append('<option value="3 bottles of each">3 bottles of each</option>');
        }
      }
    }
  /*$('.add_to_cart .text').text(current_text + " + " +optionprice).show();
    $('.second_add_to_cart .text').text(current_text + " + " +optionprice).show();*/
});
  
$("body").on("click", '.second_add_to_cart', function(e) {
    e.preventDefault();
    $('.add_to_cart').trigger('click');
});
  
  
/* End Product subscription prices update */  

/* homepage slider */
  $("body").on("click", '.cardsliderwrap .flickity-prev-next-button.next', function() {
    $('.slide.right-slide').trigger('click');
  }); 
  
  $("body").on("click", '.cardsliderwrap .flickity-prev-next-button.previous', function() {
    $('.slide.left-slide').trigger('click');
  });   
/* end homepage slider */  
  
                 $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function(cart) {
                  refreshCart(cart);

                }
              });

  $("body").on("click", '.cartimgwrap', function() {
    window.location = $("body").data("shop-url") + $(this).data('img-link');
  });   
  
  // Back button code
  

  $(document).ajaxStop(function () {
    
    
      if(performance.navigation.type == 2)
      {
        var option = (getCookie("SelectedDays") > 0? getCookie("SelectedDays"): 30);

         $("select[name='properties[shipping_interval_frequency]']").val(option).change().triggerHandler('click');
        //console.log("select set");
      }
    
  });

        function setCookie(key, value) {
            var expires = new Date();
            expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
            document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
        }

        function getCookie(key) {
            var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
            return keyValue ? keyValue[2] : null;
        }
  
        function removeCookie(key) {
            var expires = new Date();
            expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
            document.cookie = key + '=' + '' + ';';
        }
   $('body')
    .on('change', "select[name='properties[shipping_interval_frequency]']", function() {
      var option = $("select[name='properties[shipping_interval_frequency]']").val();
      setCookie("SelectedDays", option);
  });
  
  // End back button code
  
  
  // Old Side Cart Variables
  var allProductdata = '';
  var getUpsell = '';
  var getUpsellOneTime = '';
  // End Side Cart Variables
  
var allPanels = $('.accordion > dd').hide();
    
   $('.accordion-outer > dt > a, .accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(":visible")) {
      $(this).parents('.accordion').find('dd').slideUp();
      $(this).parents('.accordion').find('small').html('+');
      $(this).parents('.accordion').find('a').removeClass('orange-text');
      $(this).find('small').html('-');
      $(this).parent().next().slideDown();
      $(this).addClass('orange-text');
    } 
    else if($(this).parent().next().is(":visible")){
      $(this).find('small').html('+');
      $(this).parent().next().slideUp();
      $(this).removeClass('orange-text');
    }    
    
        return false;
  });
  
  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  objectFitImages();
  header.loadMegaMenu();
  header.init();
  
    searchAutocomplete.init();
  
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  videoSection.init();
  gallery.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();
  mapFunction.init();
  productPage.initializeQuantityBox();
  productPage.init();
  productPage.relatedProducts();
  recentlyViewed.init();

  // Setup a timer
  var resizeTimeout;

  // Listen for resize events
  window.addEventListener('resize', function ( event ) {

    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {

        // Reset timeout
        resizeTimeout = null;

        // Run our resize functions
        if($(window).width() <= 798) {
          cart.init();
          header.unload();
          header.init();
        }

      }, 66);
    }
  }, false);

  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function(instance, slide) {
    if (instance.current.type == 'image'){
      slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
    }
    if (instance.group.length > 1){
      slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')
    }
  }

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  //Search input hiding
  //get current input
  var currentValue = $(".search_form input[name='q']").val()
  //return amount without *
  if ($(".search_form input[name='q']").length > 0){
    $(".search_form input[name='q']").val( currentValue.replace('*', '') );
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
    .on('change', '#tag_filter, #sort-by', function() {
      quickFilter.init();
  });

  $('body')
    .on('change', '#blog_filter', function() {
      var url = $(this).val();
      window.location = url;
  });

  $('input, select, textarea').on('focus blur', function(event) {
    $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
  });

  //Collection sidebar filter
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
    $("html, body").animate({
      scrollTop: ($('#pagecontent').offset().top)
    }, 500);
  })

  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
      var currentVariant = $('.js-quick-shop select[name="id"]').val();
      if (currentVariant && globalQuickShopProduct){
        quickShop.updateVariant(currentVariant);
      }
  });
  
  function showdiscountprice(id) {
    $('.rc_label__discount_amount').each(function() {
      if( parseInt($( this ).data( "id" ), 10) === parseInt(id, 10) ){
        $( this ).show();
      } else {
        $( this ).hide();
      }
    });
  }    
  showdiscountprice($('.swatch_options input:checked+.swatch-element').data('id'));
  
  $('body').on('click', '.swatch-element', function(){
    //$(".rc_label__discount_amount").hide();
    var current = $(this).data("id");
    
  showdiscountprice(current);

  });

  

  var touchStartPos = 0;

  //Detecting swipe vs tap
  $(document).bind("touchstart", function (e) {
    touchStartPos = $(window).scrollTop();
  }).bind("touchend", function (e) {
      var distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
          e.preventDefault;
      }
  });

  $('body').on('click', '.sidebar .parent-link--false', function(e) {
    e.preventDefault();
    $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  

  if(window.location.pathname.indexOf('/comments') != -1) {
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', function() {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  if ($(window).width() > 798) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    arrowShape: arrowSize,
    lazyLoad: 2

  });

  utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
  utils.createAccordion('.footer_menu', 'h6', 'ul');
  utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() <= 798) {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  $('body').on('click', '.menu-toggle', function(e) {
    var $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
  });

  if ($(window).width() >= 959) {
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
  }

  

  //Terms of service settings for minicart
  

  
      $('body').on('click', ".cart_content .action_button", function(e) {
        // Redirect to cart page
        e.preventDefault();
        document.location.href = "/cart";
      });
    


  

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  
    enableLoadMoreProducts();
  

  

  

  

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "item left";
          } else {
            items_left_text = "items left";
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          $("#cart_form").submit();
        }
      }
    });
  }

function loadJSONcollection() {
  //console.log("triggered");
  var toreturn = '';
  $.ajax({
    url:  "/collections/all-products/products.json",
      async: false,
    type:  'GET'
  })
  .done(function(data) {
      console.log("done load all products");
      allProductdata = data;

  })
  .fail(function(data) {})
  .always(function(data) {});
}

  function getProductResult(data, currentItem){
    /*console.log('getProductResult');
       console.log(data);
    console.log(currentItem);*/
      var currentSKU = currentItem.sku;
      
      var toItem = checkItemSku(currentSKU);
      getUpsell =  '';
      //console.log(toItem);
      var toReplaceItems = [];
       
      $.each(data.products, function(index, subitem) {
          
          $.each(subitem.variants, function(index, subvariant) {
                  
                  $.each(toItem[1], function(indexti, toaddSKU) {
                    if(subvariant.sku == toaddSKU) {
                      //console.log(subitem);
                      //console.log(subvariant);
                      var data = {};
                      var subtitle = subitem.title;
                      var subid = '';
                      var subvarid = subvariant.id;
                      var subvarprice = subvariant.price;
                      
                      var type = $('#rc_container .rc_block__type--active input').val();
                      if(type === 'autodeliver') {                                              
                        /*console.log("Sub price");
                        console.log("Variant id: ");console.log(subvarid);
                        console.log("Sub id: ");console.log(all_subs_ids[subvarid]);
                        console.log("Sub var id: ");console.log(all_subs_variant[subvarid]);
                        console.log("Sub price: ");console.log(all_subs_price[subvarid]);*/
                        
                        subid = all_subs_ids[subvarid];
                        subvarprice = all_subs_price[subvarid];
                        subvarid = all_subs_variant[subvarid];                     
                      } else {
                        /*console.log("One time price");
                        console.log(subvarprice);*/
                        subvarprice = subvarprice*100;

                      }

                      data.Title = subtitle;
                      data.SubId = subid;
                      data.VarId = subvarid;
                      data.VarPrice = subvarprice;
                      data.Type = type;
                      
                      //toReplaceItems.unshift(data); //unshift
                      toReplaceItems.splice(indexti, 0, data);
                    }
                    
                  });
          });
              
        });
    //console.log('replace: ');console.log(toReplaceItems);
    
       /* var skip = {};
                      $.each(items, function(indexc, cartitem) {
                        if(items.length === 2){ 
                          var data = {};
                          
                          skip[cartitem.sku] = true; 
                        }
                      });*/
    $.each(data.products, function(index, item) {
            
          $.each(item.variants, function(index, variant) {
                  
              //console.log(variant.sku);
                  $.each(toItem[0], function(indexv, toItemSKU) {
                    
                    if(variant.sku == toItemSKU) {
                      /*console.log('Price');
                      console.log(parseInt(toReplaceItems[indexv].VarPrice, 10));
                      console.log(currentItem.price);

                      console.log(variant.sku);*/
                      //console.log(item);
                      //console.log(variant.id);
                      //console.log(item.metafields);
                      
                      getUpsell += '<li  class="upsell-item"> <p class="mm-counter"></p> <a href="#" class="remove-and-add" data-remove-id="'+ currentItem.id +'"'+
                        'data-var-id="'+ toReplaceItems[indexv].VarId +'"';
                      if(toReplaceItems[indexv].Type === 'autodeliver'){
                        getUpsell += ' data-subscription-id="'+ toReplaceItems[indexv].SubId+'" data-sub-type="'+$("#rc_shipping_interval_unit_type").val()+'" data-sub-freq="'+$('.rc_select__frequency').val()+'"';
                      } else {
                        getUpsell += ' data-subscription-id="" data-sub-type="" data-sub-freq="0"';
                      }
                      getUpsell += '>';
                      if(indexv === 0) {
                        getUpsell += '<h3 class="upsell-title">We also recommend:</h3>';
                      }
                      getUpsell += '<div class="cart_product_upsell">'+
                              '<div class="six columns alpha"><div class="image-element__wrap">'+
                             '<img src="' + item.images[0].src.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                         ' </div></div>'+
                            '<div class="ten columns omega cart_content_info">'+
                            '<h3 class="product_title1 product_title_'+item.id+'">'+ item.title +'</h3>'+ 
                            '<p style="font-size: 14px;">'+ item.product_type +'</p>'+ 
                            '<p><span class="add-new-price"> + add to cart  + '+  Shopify.formatMoney(((parseInt(toReplaceItems[indexv].VarPrice) - parseInt(currentItem.price, 10))), $('body').data('money-format')) +'</span></p>'+
                          '</div></div></a></li>';
                    }
                  });
          });
      });
  }
  
  
  function checkItemSku(sku) {
    var to_display = '';
    var to_replace = '';
    
      switch(sku) {
        case 'UT-1':
          to_display = ["UC-1", "UP-1"];
          to_replace = ["UK-1", "UTP-1"];
          break;
        case 'UT-2':
          to_display = ["UC-2", "UP-2"];
          to_replace = ["UK-2", "UTP-2"];
          break;
        case 'UT-3':
          to_display = ["UC-3", "UP-3"];
          to_replace = ["UK-3", "UTP-3"];
          break;
          
        case 'UC-1':
          to_display = ["UT-1", "UP-1"];
          to_replace = ["UK-1", "UCP-1"];
          break;
        case 'UC-2':
          to_display = ["UT-2", "UP-2"];
          to_replace = ["UK-2", "UCP-2"];
          break;
        case 'UC-3':
          to_display = ["UT-3", "UP-3"];
          to_replace = ["UK-3", "UCP-3"];
          break;        

        case 'UP-1':
          to_display = ["UT-1", "UC-1"];
          to_replace = ["UTP-1", "UCP-1"];
          break;
        case 'UP-2':
          to_display = ["UT-2", "UC-2"];
          to_replace = ["UTP-2", "UCP-2"];
          break;
        case 'UP-3':
          to_display = ["UT-3", "UC-3"];
          to_replace = ["UTP-3", "UCP-3"];
          break;  
          
        case 'UTP-1':
          to_display = ["UC-1"];
          to_replace = ["UKP-1"];
          break;
        case 'UTP-2':
          to_display = ["UC-2"];
          to_replace = ["UKP-2"];
          break;
        case 'UTP-3':
          to_display = ["UC-3"];
          to_replace = ["UKP-3"];
          break;          
          
        case 'UK-1':
          to_display = ["UP-1"];
          to_replace = ["UKP-1"];
          break;
        case 'UK-2':
          to_display = ["UP-2"];
          to_replace = ["UKP-2"];
          break;
        case 'UK-3':
          to_display = ["UP-3"];
          to_replace = ["UKP-3"];
          break;            
          
        case 'UCP-1':
          to_display = ["UT-1"];
          to_replace = ["UKP-1"];
          break;
        case 'UCP-2':
          to_display = ["UT-2"];
          to_replace = ["UKP-2"];
          break;
        case 'UCP-3':
          to_display = ["UT-3"];
          to_replace = ["UKP-3"];
          break;  

        default:
          to_display = '';
        to_replace = '';
      }  
  
    return [to_display, to_replace];
  }

    function checkItemSkuOneTime(sku) {
    var to_display = '';
    var to_replace = '';
    
      switch(sku) {
        case 'UT-1':
          to_display = ["UC-1", "UP-1"];
          to_replace = ["UK-1", "UTP-1"];
          break;
        case 'UT-2':
          to_display = ["UC-1", "UP-1"];
          to_replace = ["UK-2", "UTP-2"];
          break;
        case 'UT-3':
          to_display = ["UC-1", "UP-1"];
          to_replace = ["UK-3", "UTP-3"];
          break;
          
        case 'UC-1':
          to_display = ["UT-1", "UP-1"];
          to_replace = ["UK-1", "UCP-1"];
          break;
        case 'UC-2':
          to_display = ["UT-1", "UP-1"];
          to_replace = ["UK-2", "UCP-2"];
          break;
        case 'UC-3':
          to_display = ["UT-1", "UP-1"];
          to_replace = ["UK-3", "UCP-3"];
          break;        

        case 'UP-1':
          to_display = ["UT-1", "UC-1"];
          to_replace = ["UTP-1", "UCP-1"];
          break;
        case 'UP-2':
          to_display = ["UT-1", "UC-1"];
          to_replace = ["UTP-2", "UCP-2"];
          break;
        case 'UP-3':
          to_display = ["UT-1", "UC-1"];
          to_replace = ["UTP-3", "UCP-3"];
          break;  
          
        case 'UTP-1':
          to_display = ["UC-1"];
          to_replace = ["UKP-1"];
          break;
        case 'UTP-2':
          to_display = ["UC-1"];
          to_replace = ["UKP-2"];
          break;
        case 'UTP-3':
          to_display = ["UC-1"];
          to_replace = ["UKP-3"];
          break;          
          
        case 'UK-1':
          to_display = ["UP-1"];
          to_replace = ["UKP-1"];
          break;
        case 'UK-2':
          to_display = ["UP-1"];
          to_replace = ["UKP-2"];
          break;
        case 'UK-3':
          to_display = ["UP-1"];
          to_replace = ["UKP-3"];
          break;            
          
        case 'UCP-1':
          to_display = ["UT-1"];
          to_replace = ["UKP-1"];
          break;
        case 'UCP-2':
          to_display = ["UT-1"];
          to_replace = ["UKP-2"];
          break;
        case 'UCP-3':
          to_display = ["UT-1"];
          to_replace = ["UKP-3"];
          break;  

        default:
          to_display = '';
        to_replace = '';
      }  
  
    return [to_display, to_replace];
  }
  
  function getProductResultOneTime(data, currentItem, items){
      // console.log(data);
      var currentSKU = currentItem.sku;
      
      var toItem = checkItemSkuOneTime(currentSKU);
      getUpsellOneTime =  '';
    console.log('Cart items');
      console.log(items);
     //console.log(items[0].sku);
    
    var skip = {};
                      $.each(items, function(indexc, cartitem) {
                        if(items.length === 2){ 
                          var data = {};
                          
                          skip[cartitem.sku] = true; 
                        }
                      });
    console.log('Skip items');
      console.log(skip);
     /* var toReplaceItems = [];
       
      $.each(data.products, function(index, subitem) {
          
          $.each(subitem.variants, function(index, subvariant) {
                  
                  $.each(toItem[1], function(indexti, toaddSKU) {
                    if(subvariant.sku == toaddSKU) {
                      //console.log(subitem);
                      //console.log(subvariant);
                      var data = {};
                      var subtitle = subitem.title;
                      var subid = '';
                      var subvarid = subvariant.id;
                      var subvarprice = subvariant.price;
                      
                      var type = $('#rc_container .rc_block__type--active input').val();
                      if(type === 'autodeliver') {                                              

                        
                        subid = all_subs_ids[subvarid];
                        subvarprice = all_subs_price[subvarid];
                        subvarid = all_subs_variant[subvarid];                     
                      } else {
                        subvarprice = subvarprice*100;

                      }

                      data.Title = subtitle;
                      data.SubId = subid;
                      data.VarId = subvarid;
                      data.VarPrice = subvarprice;
                      data.Type = type;
                      
                      //toReplaceItems.unshift(data); //unshift
                      toReplaceItems.splice(indexti, 0, data);
                    }
                    
                  });
          });
              
        });*/
    //console.log('replace: ');console.log(toReplaceItems);
    var upsell_item = 0;
    $.each(data.products, function(index, item) {
            
          $.each(item.variants, function(index, variant) {
                  
              //console.log(variant.sku);
                  $.each(toItem[0], function(indexv, toItemSKU) {
                    
                    if(variant.sku == toItemSKU) {
                      upsell_item += 1;
                      /*console.log('Price');
                      console.log(parseInt(toReplaceItems[indexv].VarPrice, 10));
                      console.log(currentItem.price);

                      console.log(variant.sku);*/
                      //console.log(item);
                      //console.log(variant);
                      //console.log(item.metafields);
                      var toskip = false;
                      if(items.length === 2){
                        
                      console.log('Skip item check : '); 
                        $.each(skip, function (index, value) {
                          console.log(index);
                          console.log(value);
                          if( index === toItemSKU && value){
                            toskip = value;
                            
                          }
                        });
                      }

                      if( (upsell_item < 3 && items.length === 1) || (items.length === 2 && !toskip &&  items[1].sku == currentSKU)  ){
                      getUpsellOneTime += '<li  class="upsell-item"> <p class="mm-counter"></p> <a href="#" class="onetime-add" data-var-id="'+ variant.id +'"';

                      getUpsellOneTime += '>';
                      if(indexv === 0 || (items.length === 2 && !toskip &&  items[1].sku == currentSKU) ) {
                        getUpsellOneTime += '<h3 class="upsell-title">We also recommend:</h3>';
                      }
                      getUpsellOneTime += '<div class="cart_product_upsell">'+
                              '<div class="six columns alpha"><div class="image-element__wrap">'+
                             '<img src="' + item.images[0].src.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                         ' </div></div>'+
                            '<div class="ten columns omega cart_content_info">'+
                            '<h3 class="product_title1 product_title_'+item.id+'">'+ item.title +'</h3>'+ 
                            '<p style="font-size: 14px;">'+ item.product_type +'</p>'+ 
                            '<p><span class="add-new-price"> + add to cart  + '+  Shopify.formatMoney(((parseInt(variant.price, 10)*100)), $('body').data('money-format')) +'</span></p>'+
                          '</div></div></a></li>';
                    }
                    }
                  });
          });
      });
  }
  
  function refreshCart(cart) {
    $cartBtn = $(".cart-button span");
    //if ($cartBtn && $cartBtn.length) {
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");

    
      $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();
  
      if (cart.item_count == 0) {
        $cart.append('<li class="empty_cart">Your Cart is Empty</li>');
        $('.cart_count').text('').hide();
          if ( (window.location.href.indexOf("/products/") >= 0) || (window.location.href.indexOf("/cart/") >= 0) || (window.location.href.indexOf("/pages/all") >= 0)) { 
            $('.top_bar--right.top-cart').html('<a href="#cart"><span class="icon-cart"></span></a>');
          } else {
              $('.top_bar--right.top-cart').html('<a href="/pages/all" class="buy-now-mobile" style="font-size: 13px!important;color: #EC5D44;font-weight: 700;line-height: 28px;margin: 0 8px 0 5px;">BUY NOW</a>');
          }
        } else {
        var onetimeonly = [];
        $.each(cart.items, function(index, item) {
          //console.log(item);
          if(jQuery.isEmptyObject(item.properties)) {
            onetimeonly.push(item);
            }
        });
        console.log("onetimeonly ");console.log(onetimeonly);
        $.each(cart.items, function(index, item) {
          console.log("Item " + index);console.log(item);
 
          var upsell_item = 0;
          if(!jQuery.isEmptyObject(item.properties)) {
               getProductResult(allProductdata, item);
          
          var upsell = getUpsell; 

          cart_items_html += '<li class="cart_item">' +
            '<p class="mm-counter">' +
            '</p>' +
            '<a href="#" style="clear: both;" onclick="event.preventDefault();">'+
                '<div class="cart_product">'+ 
                    '<div class="six columns alpha">'+
                       '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                   ' </div>'+
                    '<div class="ten columns omega cart_content_info">'+
                      '<h3 class="product_title1 product_title_' + item.variant_id+'" >'+
                       item.title.replace('- '+item.variant_title, '') +'<div style="display:inline" id="'+ item.variant_id+'"></div> <span class="goat-divider"> |</span>'+
                             '<p class="modal_price" style="display: inline-block; margin-bottom: 0px; padding-bottom: 0px; font-weight: inherit;">'+
                        '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>'+
                      '</p>'+
                      '</h3>';
          
              cart_items_html += '<p style="font-size: 14px;margin-bottom: -5px !important;">';
              cart_items_html += '(' + item.variant_title +')<br/>';
          
           
              cart_items_html += 'Delivery every 30 days ' +'<br/>';
              
              cart_items_html += '</p>'+
                      '<div class="product-quantity-box left">' +
              '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
              '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'"  data-line-id="' + (index+1) +'" readonly />' +
              '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
            '</div>';
                
            cart_items_html += '<div class="left" style=" width: 100%; "> <span class="cart-item__remove"'+
            'data-line="' + (index+1) +'" data-id="'+ item.id +'">Remove</span> </div>'+
                  '</div></div></a></li>';
            if(upsell.length > 0) {
              cart_items_html += upsell;
            }

            
          } else {
             getProductResultOneTime(allProductdata, item, onetimeonly);
        // console.log('Function getProductResultOneTime called');
            var upsellOneTime = getUpsellOneTime; 

                      cart_items_html += '<li class="cart_item">' +
            '<p class="mm-counter">' +
            '</p>' +
            '<a href="#" style="clear: both;" onclick="event.preventDefault();">'+
                '<div class="cart_product">'+ 
                    '<div class="six columns alpha">'+
                       '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                   ' </div>'+
                    '<div class="ten columns omega cart_content_info">'+
                      '<h3 class="product_title1 product_title_' + item.variant_id+'" >'+
                       item.title.replace('- '+item.variant_title, '') +'<div style="display:inline" id="'+ item.variant_id+'"></div> <span class="goat-divider"> |</span>'+
                             '<p class="modal_price" style="display: inline-block; margin-bottom: 0px; padding-bottom: 0px; font-weight: inherit;">'+
                        '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>'+
                      '</p>'+
                      '</h3>';
          
              cart_items_html += '<p style="font-size: 14px;margin-bottom: -5px !important;">';
              cart_items_html += '(' + item.variant_title +')<br/>';

              cart_items_html += '</p>'+
                      '<div class="product-quantity-box left">' +
              '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
              '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'"  data-line-id="' + (index+1) +'" readonly />' +
              '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
            '</div>';
                
            cart_items_html += '<div class="left" style=" width: 100%; "> <span class="cart-one-time-item__remove"'+
            'data-line="' + (index+1) +'" data-id="'+ item.id +'">Remove</span> </div>'+
                  '</div></div></a></li>';
           if(upsellOneTime.length > 0) {
            cart_items_html += upsellOneTime;
           }
            
            
          }

          
        });
     
        
        cart_items_html += '<li class="mm-subtitle clearfix total checkoutbtn">';
          

          

          cart_items_html += '<span class="mm-action_buttons">' +
          '<input type="submit" class="action_button cartbutton full-width" value="Checkout '+Shopify.formatMoney(cart.total_price, $('body').data('money-format'))+'" />' + '</span>' + '</li>';

        $cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
        if(cart.item_count > 0){
          if( typeof $('.cart_count').lenght === "undefined") {
            $('.icon-cart.mini_cart.dropdown_link').html('<span class="cart_count">'+cart.item_count+'</span>');
          } else {
              $('.cart_count').text(cart.item_count).show();
          }
          $('.top_bar--right.top-cart').html('<a href="#cart"><span class="cart_count">'+cart.item_count+'</span> <span class="icon-cart"></span></a>');
        }

        
      }
    //}
  }
  
function refreshCartOneTime(cart) {
    $cartBtn = $(".cart-button span");
    //if ($cartBtn && $cartBtn.length) {
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");

    
      $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();
  
      if (cart.item_count == 0) {
        $cart.append('<li class="empty_cart">Your Cart is Empty</li>');
                     $('.cart_count').text('').hide();
      } else {
        $.each(cart.items, function(index, item) {
          //console.log("Item");console.log(item);
          getProductResultOneTime(allProductdata, item, cart.items);
          
          var upsell = getUpsell; 

          cart_items_html += '<li class="cart_item">' +
            '<p class="mm-counter">' +
            '</p>' +
            '<a href="#" style="clear: both;" onclick="event.preventDefault();">'+
                '<div class="cart_product">'+ 
                    '<div class="six columns alpha">'+
                       '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                   ' </div>'+
                    '<div class="ten columns omega cart_content_info">'+
                      '<h3 class="product_title1 product_title_' + item.variant_id+'" >'+
                       item.title.replace('- '+item.variant_title, '') +'<div style="display:inline" id="'+ item.variant_id+'"></div> <span class="goat-divider"> |</span>'+
                             '<p class="modal_price" style="display: inline-block; margin-bottom: 0px; padding-bottom: 0px; font-weight: inherit;">'+
                        '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>'+
                      '</p>'+
                      '</h3>';
          
              cart_items_html += '<p style="font-size: 14px;margin-bottom: -5px !important;">';
              cart_items_html += '(' + item.variant_title +')<br/>';

              cart_items_html += '</p>'+
                      '<div class="product-quantity-box left">' +
              '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
              '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'"  data-line-id="' + (index+1) +'" readonly />' +
              '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
            '</div>';
                
            cart_items_html += '<div class="left" style=" width: 100%; "> <span class="cart-one-time-item__remove"'+
            'data-line="' + (index+1) +'" data-id="'+ item.id +'">Remove</span> </div>'+
                  '</div></div></a></li>';
           if(upsell.length > 0) {
            cart_items_html += upsell;
           }
        });
     
        
        cart_items_html += '<li class="mm-subtitle clearfix total checkoutbtn">';
          

          

          cart_items_html += '<span class="mm-action_buttons">' +
          '<input type="submit" class="action_button cartbutton full-width" value="Checkout '+Shopify.formatMoney(cart.total_price, $('body').data('money-format'))+'" />' + '</span>' + '</li>';

        $cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
        if( typeof $('.cart_count').lenght === "undefined") {
          $('.icon-cart.mini_cart.dropdown_link').html('<span class="cart_count">'+cart.item_count+'</span>');
        } else {
          $('.cart_count').text(cart.item_count).show();
        }

        
      }
    //}
  }  
  
  
  $('body').on("change", "#cart input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart'));
  });

  $('body').on("change", "#cart_form input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $('body').on("change", ".cart_content input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
  });

  
    $(document).on('click', '.ajax-submit', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              refreshCart(cart);
              if($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }

              if($('#header').is(':visible')) {
                $('#header .cart_container').addClass('active_link');
              } else if ($('.sticky_nav--stick').length) {
                $('.sticky_nav .cart_container').addClass('active_link');
              } else {
                $('.top_bar .cart_container').addClass('active_link');
              }

              //block scrolling on mobile
              if ($(window).width() <= 798) {
                var $cart_container = $(this).parent();
                if($cart_container.hasClass('active_link')) {
                  $('body').addClass('blocked-scroll');
                } else {
                  $('body').addClass('blocked-scroll');
                }
              }
            }
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
  

  productPage.productSwatches();

});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

    if($parentSection.hasClass('page-details-section')){
      if($('.map-section').length) {
        mapFunction.init();
      }
    }

    if ($parentSection.hasClass('cart-section')){
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('product-template')){
      
    }

    utils.resizeActionButtons();

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

$(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    

    if ($parentSection.hasClass('image-gallery-section')){
      gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count'),
          column: $target.data('column')
        });
      });
    }

    if ($parentSection.hasClass('faq-section')){
      faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')){
      cart.init();
      if ($('.block__featured_collection').length){
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('featured-promotions-section')){
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    
      if ($parentSection.hasClass('search-section')){
        searchAutocomplete.init();
      }
    


    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      productPage.initializeQuantityBox();
      productPage.productSwatches();
      productPage.init();
      
    }

    if($parentSection.hasClass('map-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')){
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')){
      productPage.init();
      productPage.productSwatches();
      productPage.relatedProducts();
      recentlyViewed.init();
      
    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('collection-template-section')){
      collectionSidebarFilter.init();
    }

    if($parentSection.hasClass('contact-section')){
      mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')){
      
        searchAutocomplete.init();
      
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')){
      header.init();
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
      mapFunction.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
    }
});


$(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
      header.unload($target);
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
      productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
      videoSection.unload($target);
    }

});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});